import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "vab-main"
};
import { useSettingsStore } from '@/store/modules/settings';

import { onUnmounted } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    fixedHeader: {
      type: Boolean,
      default() {
        return true;
      }
    },
    showTabs: {
      type: Boolean,
      default() {
        return true;
      }
    }
  },
  setup(__props) {
    const settingsStore = useSettingsStore();
    const {
      foldSideBar,
      openSideBar
    } = settingsStore;
    foldSideBar();
    onUnmounted(() => {
      openSideBar();
    });
    return (_ctx, _cache) => {
      const _component_vab_side_bar = _resolveComponent("vab-side-bar");
      const _component_vab_nav = _resolveComponent("vab-nav");
      const _component_vab_tabs = _resolveComponent("vab-tabs");
      const _component_vab_app_main = _resolveComponent("vab-app-main");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["vab-layout-float", {
          fixed: __props.fixedHeader,
          'no-tabs-bar': !__props.showTabs
        }])
      }, [_createVNode(_component_vab_side_bar, {
        layout: "float"
      }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass(["vab-layout-header", {
          'fixed-header': __props.fixedHeader
        }])
      }, [_createVNode(_component_vab_nav, {
        layout: "float"
      }), _withDirectives(_createVNode(_component_vab_tabs, null, null, 512), [[_vShow, __props.showTabs]])], 2), _createVNode(_component_vab_app_main)])], 2);
    };
  }
});